import React from "react";
import style from "./QuestionBody.module.scss";
import { QAItem } from "../..";
import moment from "moment";

export default function QuestionBody({
    question
}: {
    question: QAItem | undefined;
}) {
    return (
        <div className={style.root}>
            <div>{question && question.content}</div>
            {question && (
                <div className={style.info}>
                    最后编辑时间：
                    {question.addtime &&
                        moment
                            .unix(parseInt(question.addtime.split(".")[0]))
                            .format("MM-DD HH:mm")}
                </div>
            )}
        </div>
    );
}
